import { render } from "./SimpleWrapper.vue?vue&type=template&id=08640c10"
const script = {}

import exportComponent from "/ws/483d663ba9f2473cb9ed84f25e5f2ea6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__